import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { Log } from '../util/log';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import { EntityId } from '../model/entityId';
import { CrashError } from '../model/crashError';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ErrorService extends BaseService implements ErrorHandler {

  constructor(http: HttpClient, afAuth: AngularFireAuth, private injector: Injector) { 
    super(http, afAuth);
  }

  handleError(error: any): void {

    Log.debug('error occurred: ' + error);
    Log.debug(error);

    let crashError: CrashError = new CrashError();

    try {

      let router = this.injector.get(Router);
      Log.debug('error url: ' + router.url);

      crashError.url = router.url; 

    } catch (error) {
      Log.debug('cannot get error url: ' + error);
    }

    if (error instanceof HttpErrorResponse) {
      
      // skip this kind of error
      return;

      try {

        // Backend returns unsuccessful response codes such as 404, 500 etc.				  
        console.error('error status code: ', error.status);
        console.error('error response body: ', error.message);          	  

        crashError.message = error.message;

      } catch (error) {
        Log.debug('cannot parse HttpErrorResponse: ' + error);
      }

    } else {
      
      try {

        // A client-side or network error occurred.	          
        console.error('error message: ', JSON.stringify(error.message));  

        crashError.message = error.message;

      } catch (error) {
        Log.debug('cannot get error message: ' + error);
      }
    } 

    // this.reportCrashError(crashError).subscribe(entityId => {
    //   // nothing to do
    // }, errorRes => {
    //   // nothing to do
    // });
  }

  reportCrashError(error: CrashError): Observable<EntityId> {

    Log.debug('reportCrashError: ' + JSON.stringify(error));

    return this.postData<EntityId>('crash', error).pipe(
      map((data) => {

          const o = Object.create(EntityId.prototype);
          Object.assign(o, data);
          return o;
        }
      ));
  }
}
